class StickyHeader extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    this.header = document.querySelector('.section-header');

    this.setHeaderHeight();
    this.updateHeaderBounds();

    window.matchMedia('(max-width: 990px)')
      .addEventListener('change', () => {
        this.setHeaderHeight();
        this.updateHeaderBounds();
      });

    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    if (this.headerIsAlwaysSticky)
      this.header.classList.add('shopify-section-header-sticky');

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    const h = this.header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${h}px`);
  }

  updateHeaderBounds() {
    this.headerBounds = this.header.getBoundingClientRect();
  }

  createObserver() {
    new IntersectionObserver(() => this.updateHeaderBounds())
      .observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyHeaderType = this.getAttribute('data-sticky-type');
    const threshold = 10;
    this.updateHeaderBounds();

    if (scrollTop > this.currentScrollTop + threshold &&
        scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (stickyHeaderType === 'on-scroll-up')
        this.header.style.transform = 'translateY(-20px)';
      if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));

    } else if (scrollTop < this.currentScrollTop - threshold) {
      if (stickyHeaderType === 'on-scroll-up')
        this.header.style.removeProperty('transform');
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reveal.bind(this));

    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      'shopify-section-header-hidden',
      'shopify-section-header-sticky',
      'animate'
    );
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
}

customElements.define('sticky-header', StickyHeader);

;(function() {
  const header = document.querySelector('.section-header');
  if (!header) return;

  function updateHeaderHeight() {
    const h = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${h}px`);
  }

  window.addEventListener('load', updateHeaderHeight);
  window.addEventListener('resize', updateHeaderHeight);
  if (window.ResizeObserver) {
    new ResizeObserver(updateHeaderHeight).observe(header);
  }
})();

;(function() {
  let resizeObserver = null;

  function updateHeaderHeight() {
    const header = document.querySelector('.section-header');
    if (!header) return;
    const h = header.offsetHeight;
    document.documentElement.style.setProperty('--header-height', `${h}px`);
  }

  function initResizeObserver() {
    const header = document.querySelector('.section-header');
    if (!header || !window.ResizeObserver) return;

    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    resizeObserver = new ResizeObserver(updateHeaderHeight);
    resizeObserver.observe(header);
  }

  window.addEventListener('DOMContentLoaded', () => {
    updateHeaderHeight();
    initResizeObserver();
  });

  window.addEventListener('load', () => {
    updateHeaderHeight();
    initResizeObserver();
  });

  window.addEventListener('resize', () => {
    updateHeaderHeight();
  });

  if (window.Shopify && Shopify.designMode) {
    [
      'shopify:section:load',
      'shopify:section:unload',
      'shopify:section:reorder',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:block:select',
      'shopify:block:deselect'
    ].forEach(evt => {
      document.addEventListener(evt, () => {
        // dès que le DOM de la section change :
        updateHeaderHeight();
        initResizeObserver();
      });
    });
  }
})();
